export const GLOBAL_SEARCH_ANALYTICS_EVENTS = {
  clickGlobalSearch: "click_global_search",
  clickGlobalSearchFilter: "click_global_search_filter",
  clickGlobalSearchRecent: "click_global_search_recent",
  clickGlobalSearchResult: "click_global_search_result"
} as const;

export type GlobalSearchAnalyticsPayload = {
  backofficeObjectType: string;
};
